Librarian.LoginDialog = new Class({
    Extends: Librarian.Window,
    Binds: ["onWindowLoaded", "onSubmit", "onSuccess", "onFailure"],

    options: {
        modalOverlayClose: false,
        closable: false,
        id: "LoginDialog",
        type: "modal",
        width: 400,
        height: 165,
        padding: {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
        },
        onSuccess: null
    },

    initialize: function(options) {
        this.options.title = Librarian.Lang.getString("login");
        this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/loginDialog.htm";

        this.parent(options);
    },

    onWindowLoaded: function() {
        document.removeOnKeyPress();
        var inputs = $$("#loginForm input");
        for (var i = 0; i < inputs.length; i++) {
            inputs[i].addEvent("keypress", function(e) {
                var evt = new Event(e);
                if (evt.keyCode == 13) {
                    this.onSubmit();
                    evt.stop();
                    return false;
                }
            } .bind(this));
        }

        var itemEl = $("submitButton");
        if (itemEl) {
            itemEl.id = this.options.id + '_' + itemEl.id;
            itemEl.addOnClick(this.onSubmit, this);
        }

        itemEl = $("cancelButton");
        if (itemEl) {
            itemEl.id = this.options.id + '_' + itemEl.id;
            itemEl.addOnClick(function () {
                var params = Librarian.features.sso.load ? "?sso=false" : "";
                Librarian.Utils.openPage("index.htm" + params, false);
            });
        }

        itemEl = $("loginForm");
        if (itemEl && Librarian.userInfo) {
            itemEl.id = this.options.id + '_' + itemEl.id;
            itemEl.email.value = Librarian.userInfo.Email;
            if ((Librarian.sessionType == Librarian.Session.sessionTypes.onBehalf) && Librarian.originalUserInfo)
                itemEl.email.value = Librarian.originalUserInfo.Email;
            itemEl.password.focus();
        }

        window.fireEvent("loginDialogLoaded");
    },

    onSubmit: function() {
        var credentials = this.getCredentials();
        if (!credentials) {
            var itemEl = $("passError");
            if (itemEl)
                itemEl.show();

            return;
        }

        // Hide the error message again so that the
        // user knows if the login fails multiple times.
        var errorEl = $("passError");
        if (errorEl)
            errorEl.hide();

        this.toggleDisabled(true);

        var session = new Librarian.Session();
        session.onLogon = this.onSuccess;
        session.onFailure = this.onFailure;

        session.logon(credentials.username, credentials.password);
    },

    getCredentials: function() {
        var loginFormEl = this.getElement("loginForm");
        var username = loginFormEl.email.value;
        var password = loginFormEl.password.value;

        if (!username || !password)
            return null;

        return {
            username,
            password
        };
    },

    onSuccess: function(sessionInfo) {
        if (typeof this.options.onSuccess == "function")
            this.options.onSuccess();

        if (sessionInfo)
            Librarian.sessionKey = sessionInfo.SessionKey;
        this.close();
    },

    onFailure: function(xhr) {
        if (Librarian.Session.isMfaRequired(xhr)) {
            this.handleMFA(xhr.responseText);
            return;
        }

        // Display the error message
        var itemEl = $("passError");
        if (itemEl)
            itemEl.show();

        this.toggleDisabled(false);
    },

    handleMFA: function(responseText) {
        var mfaInfo = JSON.parse(responseText);
        var credentials = this.getCredentials();

        var container = this.windowEl.getElement(".login-mfa-container");
        if (container)
            return;

        var loginPanel = this.windowEl.getElement(".loginpanel");

        container = new Element("div", {
            "class": "login-mfa-container"
        }).inject(loginPanel);

        var mfaPanel = new Librarian.Session.MFAPanel({
            container: container,
            mfaInfo: mfaInfo,
            credentials: credentials,
            onSuccess: this.onSuccess
        });

        mfaPanel.addEvent("load", function() {
            this.resize({ height: "auto" });
        }.bind(this));
    },

    toggleDisabled: function(disabled) {
        var loginFormEl = this.getElement("loginForm"),
            submitButtonEl = this.getElement("submitButton");

        loginFormEl.password.disabled = disabled;
        Librarian.Utils.setButtonDisabled(submitButtonEl, disabled);
    }
});